import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-home\"><path d=\"M939.19274611 463.05724978l-368.83115728-377.19367754c-32.04165663-32.83389539-84.59349455-32.83389539-116.63515114 2e-8l-368.83115727 377.19367752c-50.17512163 51.31946651-14.61240385 139.0819161 56.33697868 139.0819161h55.36868686v270.41749764c0 49.82301551 40.31615037 90.13916588 90.13916586 90.13916588h135.20874884V737.34791469c0-24.91150776 20.15807519-45.06958293 45.06958292-45.06958293h90.1391659c24.91150776 0 45.06958293 20.15807519 45.06958293 45.06958293v225.34791471H737.34791469c49.82301551 0 90.13916588-40.31615037 90.13916588-90.13916588V602.13916588h55.36868687c70.94938252 0 106.5121003-87.76244959 56.33697867-139.0819161z\" p-id=\"1223\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 29